if (!customElements.get('video-delay-loader')) {
  class VideoDelayLoader extends HTMLElement {
    connectedCallback() {
      const template = this.querySelector('template');
      if (!template) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            this.replaceWith(template.content.cloneNode(true));
          });
        },
        { rootMargin: '200px' }
      );

      observer.observe(this);
    }
  }

  customElements.define('video-delay-loader', VideoDelayLoader);
}
